import { AppLanguage, IUfinetSelectOption } from 'ufinet-web-functions'

export class DegradationType {
	degradationTypeId: string
	nameEs: string
	nameEn: string
	namePt: string

	constructor(id: string, nameEs: string, nameEn: string, namePt: string) {
		this.degradationTypeId = id
		this.nameEs = nameEs
		this.nameEn = nameEn
		this.namePt = namePt
	}

	static mapDegradationTypeToSelectOption(self: DegradationType, language: AppLanguage): IUfinetSelectOption {
		return {
			label: language === 'es' ? self.nameEs : language === 'en' ? self.nameEn : self.namePt,
			value: self.degradationTypeId,
		}
	}
}
